import React from 'react';
import page from '../../images/PaginaInicial.jpg';
import ReactPlayer from 'react-player';
import { useNavigate } from 'react-router-dom';

type Props = {};
/*https://www.learningcontainer.com/wp-content/uploads/2020/05/sample-mp4-file.mp4 */
const HomePage = (props: Props) => {
  const navigate = useNavigate();

  const handleVideoClick = () => {
    navigate('/caldeira'); // Redireciona para a nova página
  };


  return (
    <div> 
 <br/><br/><br/>
<ReactPlayer
  url={`/videos/page.mp4`}
  className='react-player'
  playing={true}
  controls={false}
  width='90%'
  height='80%'
  onClick={handleVideoClick}
/>


    </div>
  );
};

export default HomePage;